import { Folder, Requirement } from "../interfaces/folder.types.ts";
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api";
import { getExceptionMessage } from "../../exceptions/helpers/getExceptionMessage.ts";
import { vaultExceptions } from "../../exceptions/default/vaultExceptions.ts";

export const fetchFolderById = createAsyncThunk(
  "vault/fetchFolderById",
  async (id: string, thunkAPI) => {
    try {
      const response = await api.get<Folder>(`/docvault/folders/${id}`);
      const folder = response.data;
      if (!folder.is_active)
        return thunkAPI.rejectWithValue(
          "La solicitud de renta solicitada no está disponible en este momento",
        );

      return folder;
    } catch (error: any) {
      const msg = getExceptionMessage(
        error.response.data?.code,
        vaultExceptions.fetchFolderById,
      );
      return thunkAPI.rejectWithValue(msg);
    }
  },
);

export const fetchVaultRequirementById = createAsyncThunk(
  "vault/fetchVaultRequirementById",
  async (id: string, thunkAPI) => {
    try {
      const response = await api.get<Requirement>(
        `/docvault/requirements/${id}`,
      );
      return response.data;
    } catch (error: any) {
      const msg = getExceptionMessage(
        error.response.data?.code,
        vaultExceptions.fetchVaultRequirementById,
      );
      return thunkAPI.rejectWithValue(msg);
    }
  },
);
